import { Component, Injector, ViewChild } from '@angular/core';
import { Art57Section } from '../../../shared/ui/Art57Section/Art57Section';
import { DetailedBulkExportViewComponent } from '../../../shared/component/detailed-view/detailed-bulk-export-view/detailed-bulk-export-view.component';
import { SectionService } from '../../../shared/service/section-service/section-service';
import { SectionName } from '../../../shared/ui/SectionName';

@Component({
  selector: 'app-bulk-export',
  templateUrl: './bulk-export.component.html',
  styleUrl: './bulk-export.component.scss'
})
export class BulkExportComponent {
  @ViewChild('detail_view_component') detail_view_component!: DetailedBulkExportViewComponent;
  
  constructor(
    public injector: Injector) {
    }

  initializeSection() {
    //Nothing to do
  }

  onResetApplication() {
    this.injector.get(Art57Section).resetApplication().then(applicationReseted => {
      if (applicationReseted) {
        this.injector.get(SectionService).loadSection(SectionName.bulkexport);
      }
    });
  }

  onResetSection() {
    this.injector.get(Art57Section).resetSection(this.injector.get(Art57Section).bulkexport).then(sectionReseted => {
      if (sectionReseted) {
        this.initializeSection();
      }
    });
  }

  onRefresh(){
    
  }

  onButtonAction(buttonAction: any) {
    switch (buttonAction.action) {
      case 'resetApplication':
        this.onResetApplication();
        break;
      case 'resetSection':
        this.onResetSection();
        break;
      case 'refresh':
        this.onRefresh();
        break;
    }
  }

}
